import DOMPurify from 'dompurify';
import HtmlReactParser, { HTMLReactParserOptions } from 'html-react-parser';
import { ReactElement, Fragment } from 'react';

export function ReactHtmlParser(props: { html: string; options?: HTMLReactParserOptions }): ReactElement {
  const sanitizedHtml = DOMPurify.sanitize(props.html, { ADD_ATTR: ['target'] });
  return <Fragment>{HtmlReactParser(sanitizedHtml, props.options)}</Fragment>;
}
